export const formatServico = (item) => {
  const currentItem = { ...item };

  const { servico_forma_pagamento } = currentItem;

  if (
    servico_forma_pagamento[0].forma_de_pagamento.descricao.includes(
      'BENEFÍCIO'
    )
  ) {
    currentItem.stringParcela = 'BENEFÍCIO';
  } else {
    const parcelas = servico_forma_pagamento.map((forma) => {
      return forma.forma_de_pagamento.parcelas;
    });
    const maior_parcela = Math.max.apply(null, parcelas);
    const stringParcela =
      maior_parcela === 1 ? 'A vista' : `Até ${maior_parcela}x`;
    currentItem.stringParcela = stringParcela;
  }

  return currentItem;
};
